import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'
import type { LayoutData } from '@/types'

import Head from 'next/head'
import { Cormorant_Garamond, Geist_Mono, Manrope } from 'next/font/google'
import { Layout } from '@/components/generals/layout'

const sans = Manrope({
    subsets: ['latin']
})

const heading = Cormorant_Garamond({
    subsets: ['latin'],
    weight: ['400', '500', '600', '700'],
    style: ['normal', 'italic']
})

const mono = Geist_Mono({
    subsets: ['latin']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${heading.style.fontFamily}}`

type PageProps = {
    layout?: LayoutData
}

const App: FC<AppProps<PageProps>> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
                <meta name='viewport' content='width=device-width, initial-scale=1' />
            </Head>

            <Layout layout={pageProps.layout}>
                <Component {...pageProps} />
            </Layout>
        </div>
    )
}

export default App
